import styled from 'styled-components';
import tw from 'twin.macro';
import Button from '../../components/Button/Button';
import TitleHeader from '../../components/TitleHeader/TitleHeader';
import ListItem from '../../components/ListItem/ListItem';

export const ToggleCustomDataButton = styled(Button).attrs(() => ({
  size: 'small',
  color: 'primary'
}))(() => [tw`m-4 mr-16`]);

export const TitleHeaderForBookings = styled(TitleHeader).attrs(() => ({
  variant: 'secondary'
}))(() => [tw`pl-0 pr-16 bg-white`]);

export const ListItemForYPData = styled(ListItem)(() => [tw`mb-16`]);

export const ListItemResourceBooking = styled(ListItem)(() => [tw`mb-4`]);
